import { Dispatch } from 'react';
import { IString } from '../../../model';
import { IAPIGameItem } from '../../../model/api-modules';
import { GameEnvRegion } from '../../../model/api-modules/env';
import {
  StudioAction,
  ISelectStudioAction,
  ReduxStudioActionType,
  getStudioList,
} from '../../../store/modules/studio';

export const formatStudioList = (list: IAPIGameItem[]) => {
  const studios: IString<IAPIGameItem> = {};
  list.forEach((item) => {
    if (!studios[item.studioID]) {
      studios[item.studioID] = {
        ...item,
      };
    }
  });
  return Object.values(studios);
};

export const initStudio = async (
  studioId: string,
  gameStudioDispatch: Dispatch<StudioAction>,
  selectStudioDispatch: Dispatch<ISelectStudioAction>
) => {
  // @ts-ignore
  const studioRes = await getStudioList(gameStudioDispatch)();
  if (!studioRes) {
    return null;
  }

  const studio = studioRes?.studioList.find(
    (v: IAPIGameItem) => v.studioID === studioId
  );
  if (studio) {
    selectStudioDispatch({
      type: ReduxStudioActionType.SELECT_STUDIO,
      result: studio,
    });
    return {
      studio,
      gameList: studioRes.gameList,
    };
  }

  return null;
};

export const getGameEnvRegionName = (region: string): string => {
  for (const item of Object.entries(GameEnvRegion)) {
    if (item[1] === region) {
      return item[0];
    }
  }
  return '';
};
